import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';
import { ButtonComponent } from '../../buttons/button/button.component';
import { InputSize } from '../../enum/input-size.enum';
import { ButtonType } from '../../enum/button-type.enum';

@Component({
  selector: 'lib-filter-type-header',
  imports: [ButtonComponent],
  templateUrl: './filter-type-header.component.html',
  styleUrl: './filter-type-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterTypeHeaderComponent {
  readonly name = input.required<string>();
  readonly shouldHideButton = input<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  readonly resetClicked = input<() => void>(() => {});
  protected readonly Input = Input;
  protected readonly InputSize = InputSize;
  protected readonly ButtonType = ButtonType;
}
